import {values} from "../utils/objects";

export const apiArray = (v) => (
    !v ? (
        v
    ) : Array.isArray(v) ? (
        v
    ) : (
        values(v)
    )
);
